import axios from 'axios';
import endPoints from '../configuration/endpoints'

export const FETCH_LABELS_DATA = 'FETCH_LABELS_DATA'
export const RECEIVE_LABELS_DATA = 'RECEIVE_LABELS_DATA'
export const LABELS_DATA_ERROR = "LABELS_DATA_ERROR"

export const fetchLabelsData = () => dispatch => {
  dispatch({
    type: FETCH_LABELS_DATA
  })
  return axios.get(endPoints.labelsData).then(res => {
    dispatch({
      type: RECEIVE_LABELS_DATA,
      payload: res.data
    })
  }).catch(() => {
    dispatch({type: LABELS_DATA_ERROR})
  })
}